require('normalize.css/normalize.css')
require('../css/global.css')
require('../css/common.css')
require('./page.css')

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('video').forEach(videoElem => {
    videoElem.playbackRate = 1.5
  })
})
